export const content = {
  about: {
    title: "About Me",
    paragraphs: [
      "I am a passionate Group Manager with over a decade of experience in cloud infrastructure, cybersecurity, and backend product development. My journey in technology has been driven by a deep interest in building secure, scalable systems and leading high-performing engineering teams.",
      "Throughout my career, I've focused on delivering innovative solutions that combine technical excellence with business value. I specialize in cloud security, distributed systems, and leading cross-functional teams to build products that make a real impact."
    ]
  },
  profile: {
    title: "Profile",
    content: "Group Manager with 10+ years of experience in cloud infrastructure, cybersecurity, and backend product development. Proven success in leading cross-functional teams to build scalable, secure, and high-performing systems across multi-cloud environments (GCP, AWS, Azure). Passionate about learning, translating complex technical goals into tangible outcomes, mentoring leaders, and driving product strategy. I’m eager to leverage my skills and experience to deliver world-class security solutions."
  },
  experience: {
    title: "Work Experience",
    items: [
      {
        title: "Group Manager – Quantum Spark",
        company: "Check Point Software Technologies",
        date: "Jul 2022 - Present",
        achievements: [
          "Led an engineering organization of 30 (across four teams) delivering cloud security with network security appliance, driving product line annual revenue growth from $60M to $100M within 2 years.",
          "Spearheaded a backend redesign to a Go-based microservices architecture on Kubernetes, achieving substantial improvements in scalability and reliability to support millions of concurrent user sessions.",
          "Delivered FIPS-compliant, secure VPN features across the cloud product suite, resulting in a 30% month-over-month increase in platform usage by enterprise customers.",
          "Championed collaboration with IoT and SD-WAN teams to integrate network security capabilities into new offerings, expanding the platform's market reach and customer value.",
          "Steered product roadmap planning and represented Engineering in executive forums, aligning technical initiatives with overarching business goals."
        ]
      },
      {
        title: "Engineering Manager – Cloud Security",
        company: "Check Point Software Technologies",
        date: "Jan 2020 – Jul 2022",
        achievements: [
          "Managed 2 teams and their respective team leads (total 15 engineers) to deliver scalable and secure cloud-native services.",
          "Led development of high-scale backend microservices in Go and C#, deployed across AWS, Azure, and GCP.",
          "Drove architectural efforts focused on high availability using AWS Fargate, Lambda functions, and Linux-based auto-scaling containers.",
          "Built and maintained resilient distributed systems to support mission-critical cloud workloads.",
          "Designed and optimized data pipelines and observability tools using BigQuery and Elasticsearch."
        ]
      },
      {
        title: "Senior Team Leader",
        company: "Safe-T Data",
        date: "Feb 2018 - Jan 2020"
      },
      {
        title: "Team Leader and Developer",
        company: "CyKick Labs",
        date: "Jun 2016 – Feb 2018"
      }
    ]
  },
  skills: {
    title: "Skills",
    categories: [
      {
        title: "Languages",
        items: ["Go", "C#", "C++", "Lua", "Python", "Bash"]
      },
      {
        title: "Cloud & Infrastructure",
        items: ["GCP", "AWS", "Azure", "Kubernetes", "Docker", "Serverless"]
      },
      {
        title: "Architecture",
        items: ["Microservices", "Distributed Systems", "High-Scale Backend APIs"]
      },
      {
        title: "Security",
        items: ["Cloud Security", "OS Hardening", "Reverse Proxy", "FIPS", "VPN"]
      },
      {
        title: "Data & Observability",
        items: ["BigQuery", "Elasticsearch", "Redis", "MongoDB", "Postgres"]
      },
      {
        title: "Leadership",
        items: ["Agile", "Roadmap Ownership", "Team Building", "Strategic Planning"]
      }
    ]
  },
  languages: {
    title: "Languages",
    items: [
      { name: "English", level: "Fluent" },
      { name: "Hebrew", level: "Fluent" }
    ]
  },
  education: {
    title: "Education",
    items: [
      {
        degree: "Executive Master of Business Administration",
        institution: "Business Administration | Bar-Ilan University",
        date: "2024-2025"
      },
      {
        degree: "B.Sc. Computer Software Engineering",
        institution: "College of Engineering | Afeka College",
        date: "2012-2016"
      }
    ]
  },
  contact: {
    email: "gomri12@gmail.com",
    phone: "050-3323352",
    location: "Tel Aviv, Israel",
    linkedin: "linkedin.com/in/omri-glam"
  },
  personal: {
    name: "Omri Glam",
    title: "Group Manager (Director)",
    profileImage: "images/profile.jpg"
  }
}; 